import type { AxiosRequestConfig } from "axios"
import { useMemo } from "react"

// this is the key for the cached pending consent data
export function usePendingConsentsSWRKey(): AxiosRequestConfig | undefined {
  const swrKey = useMemo(
    () => {
      const url = "/api/v3/consents/pending"

      return {
        url,
      }
    },
    [],
  )

  return swrKey
}
